// @aiContributed-MAPFuse-2026-01-16
import $ from 'jquery'; // eslint-disable-line no-unused-vars
import Backbone from 'backbone';
import 'jquery-migrate';
import kendo from '@bingads-webui/kendo/kendo.data';
import PageContext from '@bingads-webui-static-legacy/page-context';
import schemaVnext from '@bingads-webui-campaign/campaign-ui-schemas';
import componentConfigImport from '@bingads-webui-component-legacy/config/index';
import componentStateImport from '@bingads-webui-component-legacy/state/index';
// Import Promise polyfill first to ensure it's available for legacy components
import './promise-polyfill';
import './advertiser.common';
import { initKendo } from './kendo-bootstrap';

Backbone.$ = $;

const pageContext = PageContext;
const config = componentConfigImport;
const state = componentStateImport;
const initializeKendo = initKendo;

const BingBaseUrl = 'https://bing.com/';
const MaxSelectedImagesPerAdGroupOrCampaignForV2 = 25;
const MaxSelectedImagesPerAdGroupOrCampaign = 25;

// Init globalLegacySchema
window.globalLegacySchema = {
  get(schemaName) {
    return schemaVnext[schemaName];
  },
};

/* eslint-disable */
/* istanbul ignore next */
if (!window._TL_) {
  window._TL_ = (str) => str;
}
var _TL_ = window._TL_;

export function initLegacyComponents({
  serverContext,
  permissions,
}) {
  const {
    CurrentCustomer,
    UserPreferences = {},
    CurrentAccount = {},
    CurrentAccountInActive,
    CurrentLocale,
    CurrentUser = {},
    Token,
    ServicesEndpoints = {},
    KeywordBidRange,
    KeywordCPVBidRange,
    KeywordCPMBidRange,
    ProductGroupBidRange,
    VideoViewsCPVBidRange,
    VideoViewsCPMBidRange,
    RecommendCPCBid,
    WindowsStoreAdsBidRange,
    Urls = {},
    DecimalFormatter,
    PublicPath,
    WelcomeStatus,
    UtcOffsetHours,
    IsAADUser,
  } = serverContext || {};

  const {
    AccountLevelPreferences = '{}',
    UserLevelPreferences = '{}',
  } = UserPreferences;

  const {
    CampaignAPI,
    AdInsightAPI,
    MmcAPI,
  } = ServicesEndpoints;

  const {
    ClientCenterBaseUrl = '',
  } = Urls;

  const {
    AdvertiserCustomerID,
    CurrencyCode,
    TimeZone,
  } = CurrentAccount || {};

  const {
    CultureDateTimeFormat = {},
  } = CurrentUser || {};

  const Culture = CurrentLocale;

  const TemplatesPathUrl = `${PublicPath}files/templates/`;
  const imagePath = `${PublicPath}files/images/`;

  const AudienceSettings = {
    RemarketingPolicyLink: 'http://go.microsoft.com/fwlink/?LinkId=690341',
    BulkAssociationMaxLimit: 1000000,
    BulkAudienceCriterionMaxLimit: 3000000,
  };

  config.set({
    CurrentAccount,
    CurrentCustomer,
    CurrentUser,
    IsNewUI: true,
  });

  config.set({
    Feature: {
      AdExtension: {
        AppExtensionIconBaseUrl: BingBaseUrl,
        MaxSelectedImagesPerAdGroupOrCampaign,
        MaxSelectedImagesPerAdGroupOrCampaignForV2,
      },
    },
  });

  state.set({
    advertisercustomer_id: AdvertiserCustomerID,
    customer_id: CurrentCustomer?.Id,
    user_id: CurrentUser?.Id,
    account_id: CurrentAccount?.Id,
  });

  Object.assign(pageContext, {
    Token,
    IsAADUser,
    KeywordBidRange,
    KeywordCPVBidRange,
    KeywordCPMBidRange,
    ProductGroupBidRange,
    VideoViewsCPVBidRange,
    VideoViewsCPMBidRange,
    RecommendCPCBid,
    Culture,
    CurrentAccount,
    CurrentAccountInActive,
    CurrentCustomer,
    CurrentLocale,
    CurrentUser,
    ClientInstrumentation: { isEnabled: true },
    Permissions: permissions,
    UserLevelPreferences: JSON.parse(UserLevelPreferences),
    AccountLevelPreferences: JSON.parse(AccountLevelPreferences),
    BingAdsWebApiUri: CampaignAPI,
    BingAdsAdInsightWebApiUri: AdInsightAPI,
    CultureDateTimeFormat,
    CultureName: Culture,
    CultureDayNames: CultureDateTimeFormat?.DayNames,
    CultureDayNamesShort: CultureDateTimeFormat?.AbbreviatedDayNames,
    CultureDayNamesMin: CultureDateTimeFormat?.ShortestDayNames,
    CultureMonthNames: CultureDateTimeFormat?.MonthNames,
    CultureMonthNamesShort: CultureDateTimeFormat?.AbbreviatedMonthNames,
    CultureFirstDay: CultureDateTimeFormat?.FirstDayOfWeek,
    DecimalFormatter,
    AccountCurrencyCode: CurrencyCode,
    AudienceSettings,
    CCBaseUrl: ClientCenterBaseUrl,
    WelcomeStatus,
    CultureLcid: CurrentUser?.LocaleID,
    AccountsOverviewPrefetchQuery: serverContext.AccountsOverviewPrefetchQuery,
    UtcOffsetHours,
    sessionId: serverContext.Omniture && serverContext.Omniture.SessionId,
  });

    initializeKendo(kendo, pageContext, DecimalFormatter);

  const isLocal = () => {
    const hostname = document.location.hostname.toLowerCase();
    return hostname === 'app1.localhost.ccui.devdev.bingads.microsoft.com' ||
      !/(^|\.)(bing)?ads(-int)?\.microsoft\.com$/.test(hostname);
  };
  const odataPath = isLocal() ? 'Advertiser/V2' : 'Campaign/V2';
  const batchPath = 'Advertiser/V2';

  config.set({
    'odata.path': odataPath,
    'odata.multipart_path': batchPath,
    'odata.batch_url': `${CampaignAPI}${odataPath}/$batch`,
    'odata.url': CampaignAPI,
    'adinsight.odata.url': AdInsightAPI,
    'adinsight.odata.batch_url': `${AdInsightAPI}AdInsight/V2/$batch`,
    BingAdsMmcWebApiUri: MmcAPI,
    KeywordBidRange,
    KeywordCPVBidRange,
    KeywordCPMBidRange,
    KeywordPercentCpcBidRange: { CeilingValue: 100, FloorValue: 0 },
    KeywordCommissionRateRange: { CeilingValue: 100, FloorValue: 0 },
    ProductGroupBidRange,
    VideoViewsCPVBidRange,
    VideoViewsCPMBidRange,
    RecommendCPCBid,
    WindowsStoreAdsBidRange,
    AccountTimeZone: TimeZone,
    audienceSettings: AudienceSettings,
    CurrentAccount,
    CurrentAccountInActive,
    CurrentCustomer,
    CurrentUser,
    Culture,
    CultureDateTimeFormat: CurrentUser?.CultureDateTimeFormat,
    CultureName: Culture,
    CultureDayNames: CurrentUser?.CultureDateTimeFormat?.DayNames,
    CultureDayNamesShort: CurrentUser?.CultureDateTimeFormat?.AbbreviatedDayNames,
    CultureDayNamesMin: CurrentUser?.CultureDateTimeFormat?.ShortestDayNames,
    CultureMonthNames: CurrentUser?.CultureDateTimeFormat?.MonthNames,
    CultureMonthNamesShort: CurrentUser?.CultureDateTimeFormat?.AbbreviatedMonthNames,
    CultureFirstDay: CurrentUser?.CultureDateTimeFormat?.FirstDayOfWeek,
    AccountLevelPreferences,
    UserLevelPreferences,
    culture: Culture,
    AccountCurrencyCode: CurrencyCode,
    Permissions: permissions,
    permissions,
    CultureLcid: CurrentUser?.LocaleID,
    Token,
    'odata.token': Token,
    'globalization.number.decimalpoint': DecimalFormatter?.decimalChar || '.',
    'globalization.number.groupPoint': DecimalFormatter?.groupChar || ',',
    'globalization.number.groupSize': DecimalFormatter?.groupSize || 3,
    'globalization.number.percentSymbol': DecimalFormatter?.percentSymbol || '%',
    'globalization.number.percentGroupSize': DecimalFormatter?.percentGroupSize || 3,
    'globalization.number.percentGroupSeparator': DecimalFormatter?.percentGroupSeparator || ',',
    'globalization.number.percentPositivePattern': DecimalFormatter?.percentPositivePattern || '1',
    'globalization.number.numberOfDigits': DecimalFormatter?.numberOfDigits || 2,
    'globalization.number.percentDecimalDigits': DecimalFormatter?.percentDecimalDigits || 2,
    'globalization.number.percentDecimalSeparator': DecimalFormatter?.percentDecimalSeparator || '.',
    TemplatesPathUrl,
    CCBaseUrl: ClientCenterBaseUrl,
    imagePath,
    BingAdsAdInsightWebApiUri: AdInsightAPI,
    Omniture: serverContext.Omniture,
  });

  if (CurrencyCode === 'JPY') {
    config.set({
      'globalization.number.numberOfDigits': 0,
    });
  }

  schemaVnext.appendDynamicInfoToSchema(config, schemaVnext.schemaVnextObj);
}

export function initLegacyComponentsWithServerContext(serverContext = {}) {
  const basePermissions = serverContext.Permissions || {};
  const CCUIPilots = serverContext.CCUIPilots || {};
  const dynamicCCUIPilots = CCUIPilots.dynamic || {};

  // Merge permissions in correct order
  const permissions = {
    ...basePermissions,
    ...CCUIPilots,
    ...dynamicCCUIPilots,
    dynamic: serverContext.DynamicPermissions || {},
  };

  return initLegacyComponents({
    serverContext,
    permissions,
  });
}
